export default __webpack_public_path__ + "static/media/riverwalk_crane.59502a0b.jpg";